import React from "react";
import { Reveal } from "@/components/site/Reveal";

export const SectionHeading = ({ eyebrow, title, subtitle, dark = false, align = "center" }) => (
  <Reveal className={align === "center" ? "text-center max-w-3xl mx-auto" : "max-w-3xl"}>
    {eyebrow && (
      <p className={`text-xs font-sans font-medium tracking-super-wide uppercase mb-4 ${dark ? "text-sand-brand" : "text-sea"}`}>
        {eyebrow}
      </p>
    )}
    <h2 className={`font-serif text-3xl md:text-4xl lg:text-5xl font-normal leading-tight ${dark ? "text-ivory" : "text-ocean"}`}>
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-5 text-base md:text-lg font-sans font-light leading-relaxed ${dark ? "text-ivory/75" : "text-ocean/65"}`}>
        {subtitle}
      </p>
    )}
    <div className={`brand-line mt-6 ${align === "center" ? "mx-auto" : ""}`} />
  </Reveal>
);
